import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class IpAddressService {
    checkLocal(params) {
        return axios.get(API_URL + 'ip-reputation/detail', {params: params,
            headers: authHeader() });
    }
    saveReputation(data) {
        return axios.post(API_URL + 'ip-reputation', data, {
            headers: authHeader() });
    }


    reputation(api_host, params, headers) {
        return axios.get(api_host, { params: params, headers: headers });
    }
   
}

export default new IpAddressService();
